/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".padding[_ngcontent-%COMP%]{padding:14px}.text-center[_ngcontent-%COMP%]{text-align:center}.padding-top-extra[_ngcontent-%COMP%], .padding-vertical-extra[_ngcontent-%COMP%]{padding-top:42px}.story-section[_ngcontent-%COMP%]   .text-primary[_ngcontent-%COMP%]{color:#025363}.story-section[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{color:#111;font-weight:500;font-family:\"Open Sans\",sans-serif;line-height:1.2;font-size:18px;margin:10px 0}"];
export { styles as styles };
